import { withInstall } from '@jdesign-vue/utils'
import StatisticCard from './src/base/statistic-card.vue'
import StatisticList from './src/containers/statistic-list.vue'
import StatisticGrid from './src/containers/statistic-grid.vue'
import StatisticFormula from './src/containers/statistic-formula.vue'
import StatisticGroup from './src/containers/statistic-group.vue'
import StatisticSuperGroup from './src/containers/statistic-super-group.vue'

export const JdStatisticCard = withInstall(StatisticCard)
export const JdStatisticCardList = withInstall(StatisticList)
export const JdStatisticCardGrid = withInstall(StatisticGrid)
export const JdStatisticCardFormula = withInstall(StatisticFormula)
export const JdStatisticCardGroup = withInstall(StatisticGroup)
export const JdStatisticCardSuperGroup = withInstall(StatisticSuperGroup)

export default JdStatisticCard

export {
  StatisticCard,
  StatisticList,
  StatisticGrid,
  StatisticFormula,
  StatisticGroup,
  StatisticSuperGroup,
}

export * from './src/types'
export * from './src/tokens'
export * from './src/constants'

// 在线字体加载工具，可单独使用
export { loadOnlineFont, loadJDZhengHTRegular } from './src/font-loader'
export type { FontLoadResult } from './src/font-loader'
